<form #ngForm="ngForm">
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-phone-{{ index }}-number">Phone {{ index }}</label>
        <input
          #phoneNumber
          id="{{ baseId }}-phone-{{ index }}-number"
          type="text"
          class="form-control"
          [ngClass]="{ error: showErrors(phoneNumberControl, isSubmitted), 'required': isRequired(phoneNumberControl) }"
          [specialCharacters]="['(', ')', 'x', ' ', '-']"
          [dropSpecialCharacters]="false"
          mask="000-0000||(000)000-0000 x0000000"
          formControlName="phoneNumber"
        />
        <div
          *ngIf="showErrors(phoneNumberControl, isSubmitted)"
          id="{{ baseId }}-warning-text-phone-number"
          class="incorrect-input"
          translate
        >
          {{
            phoneNumberControl.errors
              | fcListValidation : 'Phone Number' : { pattern: 'A phone number must have at least 7 digits or 10 or more digits' }
          }}
        </div>
      </div>
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-phone-{{ index }}-type">Phone Type</label>
        <ap-findcontrol
          id="{{ baseId }}-phone-{{ index }}-type"
          baseId="{{ baseId }}-phone-{{ index }}-type"
          [apFormGroup]="form"
          [form]="ngForm"
          controlName="phoneType2"
          [findControlId]="FindControlIdService.ListPhoneType"
          [(selectedPks)]="selectedPks"
          [placeHolder]=""
          (chipsChange)="onPhoneTypeDataPopulate($event)"
          [disabled]="isPhoneTypeDisabled"
          [required]="!isPhoneTypeDisabled"
          [singleSelect]="true"
          (dirty)="phoneNumberControl.markAsDirty()"
          [findControlMaxLength]="50"
          findControlDisplayName="Find Phone Type"
          [formGroupSubmitted]="!isPhoneTypeDisabled"
        >
        </ap-findcontrol>
      </div>
    </div>
  </div>
</form>
